/* eslint-disable no-underscore-dangle */
import Vue from 'vue';
import moment from 'moment';
import VueI18n from 'vue-i18n';

import { settings } from '@/config';
// import vuetify from '@/i18n/vuetify';
// import en from './en_US';
// import et from './et_EE';

const loadedLanguages = [];

Vue.use(VueI18n);

const messages = {};
// const messages = {
//   'en-US': {
//     ...en,
//     $vuetify: vuetify.en,
//   },
//   'et-EE': {
//     ...et,
//     $vuetify: vuetify.et,
//   },
// };

const defaultDateTimeFormat = {
  short: {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  },
  long: {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    weekday: 'long',
    hour: 'numeric',
    minute: 'numeric',
    hour12: false,
  },
  month: {
    year: 'numeric',
    month: '2-digit',
  },
};

const dateTimeFormats = {
  'en-US': {
    short: {
      year: 'numeric',
      month: 'numeric',
      day: 'numeric',
    },
    long: {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
    },
  },
  'et-EE': defaultDateTimeFormat,
  'rus-RU': defaultDateTimeFormat,
};

/**
 * Available locales
 */
export const locales = [
  {
    title: 'English',
    locale: 'en-US',
    abbr: 'ENG',
  },
  {
    title: 'Eesti',
    locale: 'et-EE',
    abbr: 'EST',
  },

];

/**
 * VueI18n instance
 */
export const i18n = new VueI18n({
  locale: settings.locale,
  messages,
  dateTimeFormats,
  silentTranslationWarn: process.env.NODE_ENV !== 'production',
  silentFallbackWarn: process.env.NODE_ENV !== 'production',
});

// override the method to not parse keys like `tenant.2` into ['tenant', '2']
Object.assign(i18n._path, {
  parsePathBase: i18n._path.parsePath,
  parsePath(path) {
    let hit = this._cache[path];
    if (!hit) {
      if (/\.\d+$/.test(path)) {
        hit = path;
      } else {
        return this.parsePathBase(path);
      }
      if (hit) {
        this._cache[path] = hit;
      }
    }
    return hit || [];
  },
});

export function formatDateTime(value, short, locale) {
  if (!value) return '';
  const isShort = short !== false;
  const format = isShort ? 'short' : 'long';
  const date = new Date(value.replace('Z[UTC]', '+0000'));
  if (date === 'Invalid date') { return ''; }
  if (date !== 'Invalid date' && i18n.locale === 'en-US') { return moment(date).format('DD/MM/YYYY'); }
  return i18n.d(date, format, locale);
}

export function formatMonth(value) {
  if (!value) return '';
  const date = new Date(value);
  if (date === 'Invalid date') { return ''; }
  return moment(date).format('MM/YYYY');
}

const jsonHandler = (res) => {
  try {
    return res.json();
  } catch (err) {
    return {};
  }
};

const errorHandler = (err) => {
  console.log(err);
  return {};
};

function loadLanguage(prefix, lang) {
  if (loadedLanguages.includes(lang)) {
    return Promise.resolve(messages[lang]);
  }
  const requestHeaders = new Headers();
  requestHeaders.append('pragma', 'no-cache');
  requestHeaders.append('cache-control', 'no-store');

  const requestInit = {
    method: 'GET',
    headers: requestHeaders,
  };

  const overallPromise = fetch(new Request(`/i18n/yester-${lang}.json`), requestInit)
    .then(jsonHandler, errorHandler).then((res) => res, errorHandler);
  const tenantPromise = fetch(new Request(`/i18n/${prefix}-${lang}.json`), requestInit)
    .then(jsonHandler, errorHandler).then((res) => res, errorHandler);

  return Promise.all([overallPromise, tenantPromise])
    .then((res) => {
      const result = {};
      Object.assign(result, res[0], res[1]);
      return result;
    },
    (error) => {
      console.log(error);
    }).then((msg) => {
      loadedLanguages.push(lang);
      messages[lang] = msg;
      return messages[lang];
    });
}

/**
 * Set locale to new value at Vue and Vuex.
 *
 * @param {Boolean} newLocale themeDark new value
 */
export function setLocale(locale, tenantId) {
  if (i18n.locale !== locale) {
    return loadLanguage(tenantId, locale).then((msg) => {
      i18n.setLocaleMessage(locale, msg);
    }).then(() => {
      i18n.locale = locale || settings.locale;
      // console.log(`[Locale] Set to "${locale}"`);
    });
  }
  console.warn(`[Locale] "${locale}" is current`);
  return Promise.resolve(locale);
}

export default i18n;
